import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-wrapper --main-layout" }
const _hoisted_2 = { class: "main-row" }
const _hoisted_3 = { class: "main-container" }
const _hoisted_4 = { class: "main-slot" }

import AsideMenu from "@/components/aside/AsideMenu.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AsideMenu),
        _createElementVNode("main", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ]))
}
}

})